import { SamplePack } from '@arpeggi/shared'
import { theme } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { SearchContext } from '../../../__legacy__/components/platform/new-explore/hooks/useSearch'
import { useTreeState } from '../../../__legacy__/stores/Root'
import { ArpTable } from '../../arp-table'
import { TableRow } from '../../arp-tablerow'
import { CurrentPageContext } from '../../verified-media'
import { useColorThief } from '../hooks'
import { Section } from '../primitives'

const Headers = ArpTable.Headers

const SpRemixTable: FC<{ id: number }> = observer(({ id }) => {
  const { globalPlayer } = useTreeState()
  const currentId = globalPlayer.arpMediaIndex
  return (
    <ArpTable.SPRemixRoot id={id}>
      <Headers.Root>
        <Headers.UnsortableTitle />
        <Headers.Tags />
        <Headers.UnsortableDateMinted />
        <Headers.UnsortablePlays />
        <Headers.UnsortableFavorite />
        <Headers.UnsortableDuration />
      </Headers.Root>
      <ArpTable.Table>
        {(media) => (
          <TableRow.Root media={media} active={currentId === media.id}>
            <TableRow.Main />
            <TableRow.Tags />
            <TableRow.DateMinted />
            <TableRow.Plays />
            <TableRow.Favorite />
            <TableRow.Duration />
            <TableRow.Actions />
          </TableRow.Root>
        )}
      </ArpTable.Table>
    </ArpTable.SPRemixRoot>
  )
})

export const SPRemixesTabContent: FC<{ sp: SamplePack }> = ({ sp }) => {
  const { palette } = useColorThief(sp.coverImage.url)
  const search = useState()
  const color = palette ? palette[1] : theme.colors.blackA100.value
  return (
    <CurrentPageContext.Provider value={{ samplePackId: sp?.id }}>
      <Tabs.Content value="#tracks">
        <Section.Root>
          <Section.Flare1 css={{ color }} />
          <Section.Flare2 css={{ color }} />
          <Section.Content>
            <SearchContext.Provider value={search}>
              <SpRemixTable id={sp.id} />
            </SearchContext.Provider>
          </Section.Content>
        </Section.Root>
      </Tabs.Content>
    </CurrentPageContext.Provider>
  )
}
